import React from 'react';
import { Trans } from '@lingui/macro';

import Waves from 'components/Waves';

export default function Loading() {
  return (
    <div className="h-full flex justify-center items-center">
      <div className="flex flex-col items-center">
        <Waves />
        <p className="text-secondary text-sm mt-4"><Trans>Loading...</Trans></p>
      </div>
    </div>
  );
}
